import * as React from 'react';

// tslint:disable:max-line-length
export const RadiatorIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
    <g fillRule="nonzero" transform="translate(1 1)">
      <rect width="4" height="14" x="5" rx="2" />
      <rect width="4" height="14" x="10" rx="2" />
      <rect width="4" height="14" rx="2" />
    </g>
  </svg>
);
